import { Box, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./styles.module.css";
import AllBet from "./AllBet/AllBet";
import AviatorResultPopup from "./AviatorResultPopup";
import GameScreen from "./GameScreen";
import {
  aviatoCancelButton,
  placeAviater,
  placeCashoutAviater,
} from "../../../store/slices/betSlice";
import { aviatoresult } from "../../../store/slices/casinoResultsSlice";
import useCasinoBetplace from "../../../api/useCasinoBetplace";

const SVGAddNew2 = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
  >
    <rect
      x="0.6"
      y="0.6"
      width="11.8"
      height="11.8"
      rx="2.5"
      stroke="#9AA0A6"
      strokeWidth="1.1"
    />
    <line
      x1="3.2"
      y1="6.5"
      x2="9.8"
      y2="6.5"
      stroke="#9AA0A6"
      strokeWidth="1.1"
    />
  </svg>
);

// const ArrowUp = () => (
//     <svg xmlns="http://www.w3.org/2000/svg" width="37" height="26" viewBox="0 0 37 26" fill="none">
//         <rect width="37" height="26" fill="#212121" />
//         <path d="M23 15L19 11L15 15" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
//     </svg>
// )

// const ArrowDown = () => (
//     <svg xmlns="http://www.w3.org/2000/svg" width="37" height="26" viewBox="0 0 37 26" fill="none">
//         <rect width="37" height="26" fill="#212121" />
//         <path d="M15 11L19 15L23 11" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
//     </svg>
// )

const MoreIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
  >
    <circle cx="5" cy="11" r="2" fill="#687E8B" />
    <circle cx="11" cy="11" r="2" fill="#687E8B" />
    <circle cx="17" cy="11" r="2" fill="#687E8B" />
  </svg>
);

const getOddColor = (result) => {
  if (result < 2) return "#3da9fc";
  if (result < 10) return "#913EF8";
  return "#d633ff";
};

function Aviator({ onBetSelect, showAllBet = true }) {
  const aviatorData = useSelector((state) => state.aviator);

  const lastMessage = aviatorData?.lastMessage;
  const [cashoutToast, setCashoutToast] = useState([null, null]);
     useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const backendPhase = lastMessage?.phase || "BETTING";
  const remainingTime = lastMessage?.remainingTime ?? 5;
  const liveMultiplier = lastMessage?.multiplier || 0;
  const { userId } = useSelector((state) => state.auth);
  const resultData = useSelector((state) => state.casinoResults.aviator) || [];
  const dispatch = useDispatch();
  const activeRoundId = lastMessage?.roundId;
  const [betIds, setBetIds] = useState([null, null]);
  const gameId = "2";
  const { globalBets, exposure, currentRoundId } = useCasinoBetplace(
    gameId,
    aviatorData,
    activeRoundId,
  );

  useEffect(() => {
    dispatch(aviatoresult());
  }, [dispatch]);
  const prevBackendPhaseRef = useRef(backendPhase);

  useEffect(() => {
    if (
      backendPhase === "CRASHED" &&
      prevBackendPhaseRef.current !== "CRASHED"
    ) {
      dispatch(aviatoresult());
    }
    prevBackendPhaseRef.current = backendPhase;
  }, [backendPhase, dispatch]);
  const [expanded, setExpanded] = useState(false);
  const [visibleOddsCount, setVisibleOddsCount] = useState(7);
  const [popupOpen, setPopupOpen] = useState(false);
  const [historyOpen, setHistoryOpen] = useState(false);
  const [selectedResult, setSelectedResult] = useState(null);
  const [rawInput, setRawInput] = useState(["10.00", "10.00"]);
  const [showSecondCard, setShowSecondCard] = useState(true);
  const [values, setValues] = useState([10, 10]);
  const [cardMode, setCardMode] = useState(["bet", "bet"]);
  const [autoBetOn, setAutoBetOn] = useState([false, false]);
  const [autoCashOutOn, setAutoCashOutOn] = useState([false, false]);
  const [autoCashOutValue, setAutoCashOutValue] = useState(["1.01", "1.01"]);
  const [gamePhase, setGamePhase] = useState("countdown");
  const [isBetPlaced, setIsBetPlaced] = useState([false, false]);
  const [betPlacedDuringCountdown, setBetPlacedDuringCountdown] = useState([
    false,
    false,
  ]);
  const [phase, setPhase] = useState("progress");

  const [autoCashOutEnabled, setAutoCashOutEnabled] = useState([false, false]);
  const [highlightRoundId, setHighlightRoundId] = useState(null);
  const prevResultIdsRef = useRef([]);

  useEffect(() => {
    if (resultData.length === 0) return;

    const currentIds = resultData.map((o) => o.roundId);
    const prevIds = prevResultIdsRef.current;

    if (prevIds.length > 0) {
      const newId = currentIds.find((id) => !prevIds.includes(id));

      if (newId) {
        setHighlightRoundId(newId);
        const timer = setTimeout(() => {
          setHighlightRoundId(null);
        }, 2000);

        prevResultIdsRef.current = currentIds;
        return () => clearTimeout(timer);
      }
    }

    prevResultIdsRef.current = currentIds;
  }, [resultData]);
  const [queuedForNextRound, setQueuedForNextRound] = useState([false, false]);
  const [queuedRoundId, setQueuedRoundId] = useState([null, null]);

useEffect(() => {
  if (backendPhase === "BETTING") setGamePhase("countdown");
  if (backendPhase === "WAITING") setGamePhase("locked");
  if (backendPhase === "FLYING") setGamePhase("animation");
  if (backendPhase === "CRASHED") setGamePhase("animation");
}, [backendPhase]);

useEffect(() => {
  if (backendPhase === "BETTING") setPhase("progress");
  if (backendPhase === "WAITING") setPhase("progress"); 
  if (backendPhase === "FLYING") setPhase("animation");
  if (backendPhase === "CRASHED") setPhase("animation");
}, [backendPhase]);

  const timer = Math.ceil(remainingTime);
  const visibleOdds = resultData;
  const handleAddAmount = (index, amount) => {
    setValues((prev) => {
      const updated = [...prev];
      const newVal = updated[index] + amount;
      const finalVal = newVal > 100000 ? 100000 : parseFloat(newVal.toFixed(2));
      updated[index] = finalVal;
      setRawInput((prevRaw) => {
        const u = [...prevRaw];
        u[index] = finalVal.toFixed(2);
        return u;
      });
      return updated;
    });
  };
  const handleIncrement = (index) => {
    setValues((prev) => {
      const updated = [...prev];
      const newVal = updated[index] + 10;
      const finalVal = newVal > 100000 ? 100000 : parseFloat(newVal.toFixed(2));
      updated[index] = finalVal;
      setRawInput((prevRaw) => {
        const u = [...prevRaw];
        u[index] = finalVal.toFixed(2);
        return u;
      });
      return updated;
    });
  };

  const toggleAutoBet = (cardIndex) => {
    setAutoBetOn((prev) => {
      const u = [...prev];
      u[cardIndex] = !u[cardIndex];
      return u;
    });
  };

  const toggleAutoCashOutEnabled = (cardIndex) => {
    setAutoCashOutEnabled((prev) => {
      const updated = [...prev];
      updated[cardIndex] = !updated[cardIndex];
      return updated;
    });
  };

  const handleAutoCashOutValue = (cardIndex, val) => {
    setAutoCashOutValue((prev) => {
      const updated = [...prev];
      updated[cardIndex] = val;
      return updated;
    });
  };

  const handleSetMode = (cardIndex, mode) => {
    setCardMode((prev) => {
      const updated = [...prev];
      updated[cardIndex] = mode;
      return updated;
    });
  };

const handleDecrement = (index) => {
  setValues((prev) => {
    const updated = [...prev];
    const newVal = updated[index] - 10;
    const finalVal = newVal < 10 ? 10 : parseFloat(newVal.toFixed(2));
    updated[index] = finalVal;

    setRawInput((prevRaw) => {
      const u = [...prevRaw];
      u[index] = finalVal.toFixed(2);
      return u;
    });

    return updated;
  });
};
  const handleSetValue = (index, amount) => {
    setValues((prev) => {
      const updated = [...prev];
      updated[index] = amount;
      return updated;
    });
    setRawInput((prev) => {
      const updated = [...prev];
      updated[index] = String(amount);
      return updated;
    });
  };

  const handleStageComplete = () => {
    setPhase("progress");
  };

const handleBetClick = (cardIndex) => {
  if (gamePhase === "locked") return; 
    const roundId = lastMessage?.roundId;
    const stake = values[cardIndex];
    const currentMultiplier = liveMultiplier;

    // Case 1: currently in countdown, normal bet/cancel flow
    if (gamePhase === "countdown") {
      if (!isBetPlaced[cardIndex]) {
        // ---- PLACE BET ----
        if (!roundId) {
          alert("Round ID not found!");
          return;
        }
        const rawValue = autoCashOutValue[cardIndex];
        const parsed = parseFloat(rawValue);
        const autoCashoutMultiplier =
          autoCashOutEnabled[cardIndex] && !isNaN(parsed) ? parsed : null;

        dispatch(
          placeAviater({ userId, roundId, stake, autoCashoutMultiplier }),
        )
          .then((res) => {
            // ---- BACKEND ERROR CHECK ----
            if (res?.meta?.requestStatus === "rejected" || res?.error) {
              const errMsg =
                res?.payload?.message ||
                res?.error?.message ||
                "Failed to place bet. Please try again.";
              alert(errMsg);
              // revert optimistic UI since bet failed
              setIsBetPlaced((prev) => {
                const u = [...prev];
                u[cardIndex] = false;
                return u;
              });
              setBetPlacedDuringCountdown((prev) => {
                const u = [...prev];
                u[cardIndex] = false;
                return u;
              });
              return;
            }

            const payload = res?.payload || res;
            const betId = payload?.id;

            setBetIds((prev) => {
              const u = [...prev];
              u[cardIndex] = betId;
              return u;
            });

            localStorage.setItem(
              `aviator_bet_${userId}_${cardIndex}`,
              JSON.stringify({ roundId, stake, betId }),
            );
          })
          .catch((err) => {
            alert(err?.message || "Something went wrong while placing bet.");
            setIsBetPlaced((prev) => {
              const u = [...prev];
              u[cardIndex] = false;
              return u;
            });
            setBetPlacedDuringCountdown((prev) => {
              const u = [...prev];
              u[cardIndex] = false;
              return u;
            });
          });

        setIsBetPlaced((prev) => {
          const u = [...prev];
          u[cardIndex] = true;
          return u;
        });
        setBetPlacedDuringCountdown((prev) => {
          const u = [...prev];
          u[cardIndex] = true;
          return u;
        });
      } else {
        // ---- CANCEL BET ----
        dispatch(
          aviatoCancelButton({
            userId,
            roundId,
            betId: betIds[cardIndex],
          }),
        )
          .then((res) => {
            if (res?.meta?.requestStatus === "rejected" || res?.error) {
              const errMsg =
                res?.payload?.message ||
                res?.error?.message ||
                "Failed to cancel bet.";
              alert(errMsg);
            }
          })
          .catch((err) => {
            alert(err?.message || "Something went wrong while cancelling bet.");
          });

        setIsBetPlaced((prev) => {
          const u = [...prev];
          u[cardIndex] = false;
          return u;
        });
        setBetPlacedDuringCountdown((prev) => {
          const u = [...prev];
          u[cardIndex] = false;
          return u;
        });
        setBetIds((prev) => {
          const u = [...prev];
          u[cardIndex] = null;
          return u;
        });
        localStorage.removeItem(`aviator_bet_${userId}_${cardIndex}`);
      }
      return;
    }

    if (
      gamePhase === "animation" &&
      !queuedForNextRound[cardIndex] &&
      !(isBetPlaced[cardIndex] && betPlacedDuringCountdown[cardIndex])
    ) {
      setQueuedForNextRound((prev) => {
        const u = [...prev];
        u[cardIndex] = true;
        return u;
      });
      setQueuedRoundId((prev) => {
        const u = [...prev];
        u[cardIndex] = roundId;
        return u;
      });
      return;
    }

    if (gamePhase === "animation" && queuedForNextRound[cardIndex]) {
      setQueuedForNextRound((prev) => {
        const u = [...prev];
        u[cardIndex] = false;
        return u;
      });
      setQueuedRoundId((prev) => {
        const u = [...prev];
        u[cardIndex] = null;
        return u;
      });
      return;
    }

    // Case 4: FLYING phase, bet is live for THIS round -> Cashout
    if (
      gamePhase === "animation" &&
      isBetPlaced[cardIndex] &&
      betPlacedDuringCountdown[cardIndex]
    ) {
      if (!roundId) {
        alert("Round ID not found!");
        return;
      }
      dispatch(
        placeCashoutAviater({
          userId,
          roundId,
          betId: betIds[cardIndex],
          cashoutMultiplier: currentMultiplier,
          autoCashoutMultiplier:
            cardMode[cardIndex] === "auto"
              ? parseFloat(autoCashOutValue[cardIndex])
              : null,
        }),
      )
        .then((res) => {
          // ---- BACKEND ERROR CHECK ----
          if (res?.meta?.requestStatus === "rejected" || res?.error) {
            const errMsg =
              res?.payload?.message ||
              res?.error?.message ||
              "Cashout failed. Please try again.";
            alert(errMsg);
            return;
          }

          const payload = res?.payload || res;
          setCashoutToast((prev) => {
            const u = [...prev];
            u[cardIndex] = {
              multiplier: payload.cashoutMultiplier,
              amount: payload.winningAmount,
            };
            return u;
          });
          setTimeout(() => {
            setCashoutToast((prev) => {
              const u = [...prev];
              u[cardIndex] = null;
              return u;
            });
          }, 2000);
        })
        .catch((err) => {
          alert(err?.message || "Something went wrong during cashout.");
        });

      setIsBetPlaced((prev) => {
        const u = [...prev];
        u[cardIndex] = false;
        return u;
      });
      setBetPlacedDuringCountdown((prev) => {
        const u = [...prev];
        u[cardIndex] = false;
        return u;
      });
      setBetIds((prev) => {
        const u = [...prev];
        u[cardIndex] = null;
        return u;
      });
      localStorage.removeItem(`aviator_bet_${userId}_${cardIndex}`);
    }
  };
  useEffect(() => {
    if (!userId) return;
    if (!lastMessage?.roundId) return;

    const restored = [false, false];
    const restoredDuring = [false, false];
    const restoredBetIds = [null, null];
    const restoredValues = [...values];

    [0, 1].forEach((cardIndex) => {
      const saved = localStorage.getItem(`aviator_bet_${userId}_${cardIndex}`);
      if (saved) {
        const { roundId, stake, betId } = JSON.parse(saved);
        if (roundId === lastMessage.roundId) {
          restored[cardIndex] = true;
          restoredDuring[cardIndex] = true;
          restoredBetIds[cardIndex] = betId;
          restoredValues[cardIndex] = stake;
        } else {
          localStorage.removeItem(`aviator_bet_${userId}_${cardIndex}`);
        }
      }
    });

    setIsBetPlaced(restored);
    setBetPlacedDuringCountdown(restoredDuring);
    setBetIds(restoredBetIds);
    setValues(restoredValues);
  }, [userId, lastMessage?.roundId]);

useEffect(() => {
  if (backendPhase !== "FLYING") return;

  [0, 1].forEach((cardIndex) => {
    if (
      isBetPlaced[cardIndex] &&
      betPlacedDuringCountdown[cardIndex] &&
      autoCashOutEnabled[cardIndex] && // fixed: was missing [cardIndex]
      cardMode[cardIndex] === "auto"
    ) {
      const target = parseFloat(autoCashOutValue[cardIndex]);
      if (!isNaN(target) && liveMultiplier >= target) {
        const roundId = lastMessage?.roundId;
        if (!roundId) return;

        dispatch(
          placeCashoutAviater({
            userId,
            roundId,
            betId: betIds[cardIndex],
            cashoutMultiplier: liveMultiplier,
            autoCashoutMultiplier: target,
          }),
        )
          .then((res) => {
            // ---- BACKEND ERROR CHECK ----
            if (res?.meta?.requestStatus === "rejected" || res?.error) {
              const errMsg =
                res?.payload?.message ||
                res?.error?.message ||
                "Auto cashout failed. Please try again.";
              alert(errMsg);
              return;
            }

            const payload = res?.payload || res;
            setCashoutToast((prev) => {
              const u = [...prev];
              u[cardIndex] = {
                multiplier: payload.cashoutMultiplier,
                amount: payload.winningAmount,
              };
              return u;
            });
            setTimeout(() => {
              setCashoutToast((prev) => {
                const u = [...prev];
                u[cardIndex] = null;
                return u;
              });
            }, 3000);
          })
          .catch((err) => {
            alert(
              err?.message ||
                "Something went wrong during auto cashout.",
            );
          });

        setIsBetPlaced((prev) => {
          const u = [...prev];
          u[cardIndex] = false;
          return u;
        });
        setBetPlacedDuringCountdown((prev) => {
          const u = [...prev];
          u[cardIndex] = false;
          return u;
        });
        localStorage.removeItem(`aviator_bet_${userId}_${cardIndex}`);
      }
    }
  });
}, [liveMultiplier, backendPhase]);;

useEffect(() => {
  [0, 1].forEach((cardIndex) => {
    if (
      queuedForNextRound[cardIndex] &&
      backendPhase === "BETTING" &&
      lastMessage?.roundId &&
      lastMessage.roundId !== queuedRoundId[cardIndex]
    ) {
      const roundId = lastMessage.roundId;
      const stake = values[cardIndex];
      const rawValue = autoCashOutValue[cardIndex];
      const parsed = parseFloat(rawValue);
      const autoCashoutMultiplier =
        cardMode[cardIndex] === "auto" &&
        autoCashOutEnabled[cardIndex] &&
        !isNaN(parsed)
          ? parsed
          : null;

      const delay = cardIndex * 2000; // card0 turant, card1 2 sec baad

      setTimeout(() => {
        dispatch(
          placeAviater({ userId, roundId, stake, autoCashoutMultiplier }),
        )
          .then((res) => {
            // ---- BACKEND ERROR CHECK ----
            if (res?.meta?.requestStatus === "rejected" || res?.error) {
              const errMsg =
                res?.payload?.message ||
                res?.error?.message ||
                "Failed to place bet.";
              alert(errMsg);

              // revert optimistic UI since bet failed
              setIsBetPlaced((prev) => {
                const u = [...prev];
                u[cardIndex] = false;
                return u;
              });
              setBetPlacedDuringCountdown((prev) => {
                const u = [...prev];
                u[cardIndex] = false;
                return u;
              });
              localStorage.removeItem(`aviator_bet_${userId}_${cardIndex}`);
              return;
            }

            const payload = res?.payload || res;
            const betId = payload?.id;
            setBetIds((prev) => {
              const u = [...prev];
              u[cardIndex] = betId;
              return u;
            });
          })
          .catch((err) => {
            alert(err?.message || "Something went wrong while placing bet.");

            setIsBetPlaced((prev) => {
              const u = [...prev];
              u[cardIndex] = false;
              return u;
            });
            setBetPlacedDuringCountdown((prev) => {
              const u = [...prev];
              u[cardIndex] = false;
              return u;
            });
            localStorage.removeItem(`aviator_bet_${userId}_${cardIndex}`);
          });

        setIsBetPlaced((prev) => {
          const u = [...prev];
          u[cardIndex] = true;
          return u;
        });
        setBetPlacedDuringCountdown((prev) => {
          const u = [...prev];
          u[cardIndex] = true;
          return u;
        });
        setQueuedForNextRound((prev) => {
          const u = [...prev];
          u[cardIndex] = false;
          return u;
        });
        setQueuedRoundId((prev) => {
          const u = [...prev];
          u[cardIndex] = null;
          return u;
        });

        localStorage.setItem(
          `aviator_bet_${userId}_${cardIndex}`,
          JSON.stringify({ roundId, stake }),
        );
      }, delay);
    }
  });
}, [backendPhase, lastMessage?.roundId]);

  const handleOpenPopup = (odd) => {
    setSelectedResult({
      roundId: odd.roundId,
      matchTime: new Date(odd.settledAt).toLocaleString(),
      value: `${odd.result.toFixed(2)}x`,
      textColor: getOddColor(odd.result),
    });
    setPopupOpen(true);
  };
const isLockedPhase = gamePhase === "locked";
  const renderCard = (cardIndex) => {
    const isCancelState = isBetPlaced[cardIndex] && gamePhase === "countdown";
    const isCashoutState =
      gamePhase === "animation" &&
      isBetPlaced[cardIndex] &&
      betPlacedDuringCountdown[cardIndex];
    const isQueuedState = queuedForNextRound[cardIndex]; 
    const isStakeLocked = isCancelState || isCashoutState || isQueuedState ||isLockedPhase;

    const cardClassName = [
      styles.Card,
      isCancelState || isQueuedState ? styles.CardCancelActive : "", 
      isCashoutState ? styles.CardCashoutActive : "",
    ]
      .filter(Boolean)
      .join(" ");

    return (
      <Box className={cardClassName}>
        <Box
          sx={{
            position: "relative",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box className={styles.ToggleContainer}>
            <Box
              className={
                cardMode[cardIndex] === "bet"
                  ? styles.ActiveToggleBox
                  : styles.InActiveToggleBox
              }
              onClick={() => !isStakeLocked && handleSetMode(cardIndex, "bet")}
              style={{
                cursor: isStakeLocked ? "not-allowed" : "pointer",
                opacity: isStakeLocked ? 0.4 : 1,
                pointerEvents: isStakeLocked ? "none" : "auto",
              }}
            >
              <Typography
                className={
                  cardMode[cardIndex] === "bet"
                    ? styles.ActiveToggleText
                    : styles.InActiveToggleText
                }
              >
                Bet
              </Typography>
            </Box>
            <Box
              className={
                cardMode[cardIndex] === "auto"
                  ? styles.ActiveToggleBox
                  : styles.InActiveToggleBox
              }
              onClick={() => !isStakeLocked && handleSetMode(cardIndex, "auto")}
              style={{
                cursor: isStakeLocked ? "not-allowed" : "pointer",
                opacity: isStakeLocked ? 0.4 : 1,
                pointerEvents: isStakeLocked ? "none" : "auto",
              }}
            >
              <Typography
                className={
                  cardMode[cardIndex] === "auto"
                    ? styles.ActiveToggleText
                    : styles.InActiveToggleText
                }
              >
                Auto
              </Typography>
            </Box>
          </Box>
          {cardIndex === 0 && !showSecondCard && (
            <Box
              className={styles.AddNewContainerBtn}
              onClick={() => setShowSecondCard(true)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
              >
                <path
                  d="M9.91451 2.46707H4.54007C4.25997 2.43453 3.97614 2.46576 3.70982 2.55843C3.4435 2.6511 3.20159 2.8028 3.0022 3.0022C2.8028 3.20159 2.6511 3.4435 2.55843 3.70982C2.46576 3.97614 2.43453 4.25997 2.46707 4.54007V9.91451C2.43453 10.1946 2.46576 10.4784 2.55843 10.7448C2.6511 11.0111 2.8028 11.253 3.0022 11.4524C3.20159 11.6518 3.4435 11.8035 3.70982 11.8962C3.97614 11.9888 4.25997 12.0201 4.54007 11.9875H9.91451C10.1946 12.0201 10.4784 11.9888 10.7448 11.8962C11.0111 11.8035 11.253 11.6518 11.4524 11.4524C11.6518 11.253 11.8035 11.0111 11.8962 10.7448C11.9888 10.4784 12.0201 10.1946 11.9875 9.91451V4.54007C12.0201 4.25997 11.9888 3.97614 11.8962 3.70982C11.8035 3.4435 11.6518 3.20159 11.4524 3.0022C11.253 2.8028 11.0111 2.6511 10.7448 2.55843C10.4784 2.46576 10.1946 2.43453 9.91451 2.46707ZM11.0662 9.91451C11.0662 10.7326 10.7326 11.0662 9.91451 11.0662H4.54007C3.72193 11.0662 3.38841 10.7326 3.38841 9.91451V4.54007C3.38841 3.72193 3.72193 3.38841 4.54007 3.38841H9.91451C10.7326 3.38841 11.0662 3.72193 11.0662 4.54007V9.91451ZM0.93152 2.08011V7.46069C0.93152 8.19776 1.22819 8.37772 1.32585 8.4373C1.42539 8.50334 1.49544 8.60541 1.52124 8.72204C1.54705 8.83867 1.52661 8.96077 1.46421 9.06263C1.40182 9.16449 1.30235 9.23818 1.18673 9.26819C1.07111 9.29819 0.948352 9.28218 0.8443 9.22351C0.559552 9.03188 0.331773 8.76698 0.184974 8.45674C0.0381742 8.14649 -0.0222093 7.80238 0.0101878 7.46069V2.08011C-0.0189399 1.80113 0.0145813 1.51916 0.108306 1.25478C0.20203 0.990403 0.353593 0.750281 0.551937 0.551937C0.750281 0.353593 0.990403 0.20203 1.25478 0.108306C1.51916 0.0145813 1.80113 -0.0189399 2.08011 0.0101878H7.46069C7.80243 -0.0226104 8.14667 0.0375937 8.45699 0.184428C8.76731 0.331262 9.03216 0.559264 9.22351 0.8443C9.25513 0.895883 9.27628 0.953188 9.28575 1.01294C9.29522 1.0727 9.29283 1.13374 9.27871 1.19257C9.2646 1.2514 9.23903 1.30688 9.20348 1.35583C9.16792 1.40478 9.12307 1.44625 9.07149 1.47787C9.01991 1.50949 8.9626 1.53064 8.90284 1.54011C8.84309 1.54958 8.78205 1.54719 8.72322 1.53308C8.66439 1.51896 8.60891 1.49339 8.55996 1.45784C8.51101 1.42228 8.46954 1.37743 8.43792 1.32585C8.3765 1.22819 8.19653 0.93152 7.46069 0.93152H2.08011C1.26443 0.93152 0.93152 1.26443 0.93152 2.08011ZM9.22351 7.22729C9.22351 7.34946 9.17497 7.46664 9.08858 7.55303C9.00219 7.63942 8.88502 7.68795 8.76284 7.68795H7.68795V8.76284C7.68795 8.88502 7.63942 9.00219 7.55303 9.08858C7.46664 9.17497 7.34946 9.22351 7.22729 9.22351C7.10511 9.22351 6.98794 9.17497 6.90155 9.08858C6.81516 9.00219 6.76662 8.88502 6.76662 8.76284V7.68795H5.69173C5.56956 7.68795 5.45239 7.63942 5.366 7.55303C5.2796 7.46664 5.23107 7.34946 5.23107 7.22729C5.23107 7.10511 5.2796 6.98794 5.366 6.90155C5.45239 6.81516 5.56956 6.76662 5.69173 6.76662H6.76662V5.69173C6.76662 5.56956 6.81516 5.45239 6.90155 5.366C6.98794 5.2796 7.10511 5.23107 7.22729 5.23107C7.34946 5.23107 7.46664 5.2796 7.55303 5.366C7.63942 5.45239 7.68795 5.56956 7.68795 5.69173V6.76662H8.76284C8.88502 6.76662 9.00219 6.81516 9.08858 6.90155C9.17497 6.98794 9.22351 7.10511 9.22351 7.22729Z"
                  fill="#49A712"
                />
              </svg>
            </Box>
          )}
          {cardIndex === 1 && (
            <Box
              className={styles.AddNewContainerBtn}
              onClick={() => setShowSecondCard(false)}
              style={{ cursor: "pointer", position: "absolute", right: 8 }}
            >
              {SVGAddNew2}
            </Box>
          )}
        </Box>

        <Box className={styles.CardInnerBox}>
          <Box
            className={styles.CardInnerBox1}
            style={{
              opacity: isStakeLocked ? 0.4 : 1,
              pointerEvents: isStakeLocked ? "none" : "auto",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                width: "100%",
              }}
            >
              <Box className={styles.StepperGroup}>
                <Box
                  className={styles.ButtonBox1}
                  onClick={() => handleDecrement(cardIndex)}
                  style={{ cursor: "pointer" }}
                >
                  <Typography className={styles.ButtonBoxText}>-</Typography>
                </Box>
                <Box className={styles.ButtonBox2}>
                  <Box className={styles.StepperInputBox}>
                    <input
                      type="text"
                      inputMode="numeric"
                      value={rawInput[cardIndex]}
                      className={styles.StepperInputField}
                      style={{
                        width: `${rawInput[cardIndex].length + 0.6}ch`,
                        fontSize:
                          rawInput[cardIndex].length >= 8 ? "13px" : "16px",
                      }}
                     onFocus={() => {
  setRawInput((prev) => {
    const u = [...prev];
    u[cardIndex] = "";
    return u;
  });
}}
                      onKeyDown={(e) => {
                        const key = e.key;
                        const current = rawInput[cardIndex] || "";
                        const intPart = current.split(".")[0] || "";

                        const updateVal = (newIntStr) => {
                          if (newIntStr === "") {
                            setRawInput((prev) => {
                              const u = [...prev];
                              u[cardIndex] = "";
                              return u;
                            });
                            return;
                          }
                          let intVal = newIntStr.replace(/^0+(?=\d)/, "");
                          if (parseInt(intVal, 10) > 100000) intVal = "100000";
                          const display = `${intVal}.00`;

                          setRawInput((prev) => {
                            const u = [...prev];
                            u[cardIndex] = display;
                            return u;
                          });
                          setValues((prev) => {
                            const u = [...prev];
                            u[cardIndex] = parseFloat(intVal);
                            return u;
                          });
                        };

                        if (key === "Backspace" || key === "Delete") {
                          e.preventDefault();
                          updateVal(intPart.slice(0, -1));
                          return;
                        }

                        if (/^[0-9]$/.test(key)) {
                          e.preventDefault();
                          updateVal(intPart + key);
                          return;
                        }

                        if (!["Tab", "ArrowLeft", "ArrowRight"].includes(key)) {
                          e.preventDefault();
                        }
                      }}
                      onPaste={(e) => {
                        e.preventDefault();
                        const pasted = e.clipboardData
                          .getData("text")
                          .replace(/[^0-9]/g, "");
                        const current =
                          (rawInput[cardIndex] || "").split(".")[0] || "";
                        let intVal = (current + pasted).replace(
                          /^0+(?=\d)/,
                          "",
                        );
                        if (parseInt(intVal, 10) > 100000) intVal = "100000";
                        const display = intVal === "" ? "" : `${intVal}.00`;

                        setRawInput((prev) => {
                          const u = [...prev];
                          u[cardIndex] = display;
                          return u;
                        });
                        if (intVal !== "") {
                          setValues((prev) => {
                            const u = [...prev];
                            u[cardIndex] = parseFloat(intVal);
                            return u;
                          });
                        }
                      }}
                      onChange={() => {}}
                      onBlur={() => {
                        let num = parseFloat(rawInput[cardIndex]);
                        if (isNaN(num) || num < 10) num = 10;
                        if (num > 100000) num = 100000;

                        setValues((prev) => {
                          const u = [...prev];
                          u[cardIndex] = num;
                          return u;
                        });
                        setRawInput((prev) => {
                          const u = [...prev];
                          u[cardIndex] = num.toFixed(2);
                          return u;
                        });
                      }}
                    />
                  </Box>
                </Box>
                <Box
                  className={styles.ButtonBox3}
                  onClick={() => handleIncrement(cardIndex)}
                  style={{ cursor: "pointer" }}
                >
                  <Typography className={styles.ButtonBoxText}>+</Typography>
                </Box>
              </Box>
            </Box>
            <Box className={styles.CardInnerBox2}>
              <Box className={styles.CardInnerBox3}>
                {[10, 100].map((amount) => (
                  <Box
                    key={amount}
                    className={styles.NoButtonBox}
                    onClick={() => handleAddAmount(cardIndex, amount)}
                  >
                    <Typography className={styles.NoButtonBoxText}>
                      {amount}
                    </Typography>
                  </Box>
                ))}
              </Box>
              <Box className={styles.CardInnerBox3}>
                {[500, 1000].map((amount) => (
                  <Box
                    key={amount}
                    className={styles.NoButtonBox}
                    onClick={() => handleAddAmount(cardIndex, amount)}
                    style={{ cursor: "pointer" }}
                  >
                    <Typography className={styles.NoButtonBoxText}>
                      {amount}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>

          {isBetPlaced[cardIndex] && gamePhase === "countdown" ? (
            <Box
              className={styles.BetButtonRed}
              onClick={() => handleBetClick(cardIndex)}
              style={{ cursor: "pointer", height: "80px", width: "100%" }}
            >
              <Typography
                sx={{ fontSize: "20px", fontWeight: 400, color: "#fff" }}
              >
                CANCEL
              </Typography>
            </Box>
          ) : queuedForNextRound[cardIndex] ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "4px",
                flex: 1,
              }}
            >
              <Typography
                sx={{ fontSize: "12px", fontWeight: 600, color: "#fff" }}
              >
                Waiting For next Round
              </Typography>
              <Box
                className={styles.BetButtonRed}
                onClick={() => handleBetClick(cardIndex)}
                style={{ cursor: "pointer", height: "44px", width: "100%" }}
              >
                <Typography
                  sx={{ fontSize: "20px", fontWeight: 400, color: "#fff" }}
                >
                  CANCEL
                </Typography>
              </Box>
            </Box>
          ) : (
           <Box
  className={
    gamePhase === "animation" &&
    isBetPlaced[cardIndex] &&
    betPlacedDuringCountdown[cardIndex]
      ? styles.BetButtonYellow
      : styles.BetButtonGreen
  }
  onClick={() => handleBetClick(cardIndex)}
  style={{
    cursor: isLockedPhase ? "not-allowed" : "pointer",
    opacity: isLockedPhase ? 0.5 : 1,
    pointerEvents: isLockedPhase ? "none" : "auto",
  }}
>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Typography
                  sx={{ fontSize: "20px", fontWeight: 400, color: "#fff" }}
                >
                   {(gamePhase === "animation" || isLockedPhase) &&
                  isBetPlaced[cardIndex] &&
                  betPlacedDuringCountdown[cardIndex]
                    ? "CASHOUT"
                    : "BET"}
                </Typography>
                <Typography
                  sx={{ fontSize: "20px", fontWeight: 400, color: "#fff" }}
                >
                  {(gamePhase === "animation" || isLockedPhase) &&
                  isBetPlaced[cardIndex] &&
                  betPlacedDuringCountdown[cardIndex]
                    ? `${(values[cardIndex] * liveMultiplier).toFixed(2)} INR`
                    : `${values[cardIndex].toFixed(2)} INR`}
                </Typography>
              </Box>
            </Box>
          )}
        </Box>

        {cardMode[cardIndex] === "auto" && (
          <Box className={styles.AutoOptionsRow}>
            <Box className={styles.AutoOptionItem}>
              <Typography className={styles.AutoOptionText}>
                Auto Cash Out
              </Typography>
              <Box
                className={
                  autoCashOutEnabled[cardIndex]
                    ? styles.SwitchOn
                    : styles.SwitchOff
                }
                onClick={() =>
                  !isStakeLocked && toggleAutoCashOutEnabled(cardIndex)
                }
                style={{
                  cursor: isStakeLocked ? "not-allowed" : "pointer",
                  opacity: isStakeLocked ? 0.4 : 1,
                  pointerEvents: isStakeLocked ? "none" : "auto",
                }}
              >
                <Box
                  className={`${styles.SwitchKnob} ${autoCashOutEnabled[cardIndex] ? styles.SwitchKnobOn : ""}`}
                />
              </Box>
            </Box>

            <Box
              className={styles.AutoCashOutValueBox}
              style={{
                opacity:
                  autoCashOutEnabled[cardIndex] && !isStakeLocked ? 1 : 0.4,
                pointerEvents:
                  autoCashOutEnabled[cardIndex] && !isStakeLocked
                    ? "auto"
                    : "none",
              }}
            >
              <input
                type="text"
                inputMode="decimal"
                value={autoCashOutValue[cardIndex]}
                disabled={!autoCashOutEnabled[cardIndex] || isStakeLocked}
                className={styles.AutoCashOutInput}
                onChange={(e) =>
                  handleAutoCashOutValue(cardIndex, e.target.value)
                }
              />
              <Typography className={styles.AutoCashOutClear}>x</Typography>
            </Box>
          </Box>
        )}
      </Box>
    );
  };

  return (
    <Box className={styles.MatchScreen_container}>
      <Box
        className={styles.visibleOdds_container}
        sx={{ display: "flex", alignItems: "center" }}
      >
        <Box className={styles.visibleOdds_box}>
          {visibleOdds.map((odd, index) => (
            <Box
              key={index}
              className={`${styles.visibleOdds_btn} ${odd.roundId === highlightRoundId ? styles.HighlightOdds : ""}`}
              sx={{ cursor: "pointer" }}
              onClick={() => handleOpenPopup(odd)}
            >
              <Typography
                className={styles.visibleOdds_btn_txt}
                sx={{ color: getOddColor(odd.result) }}
              >
                {odd.result.toFixed(2)}x
              </Typography>
            </Box>
          ))}
        </Box>
        <Box
          className={styles.Arrow_box}
          onClick={() => setHistoryOpen(true)}
          sx={{
            cursor: "pointer",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "50%",
            background: "#141516",
          }}
        >
          <MoreIcon />
        </Box>
      </Box>

      <Box
        sx={{
          position: "relative",
          width: "100%",
          display: "flex",
          px: "5px",
          boxSizing: "border-box",
        }}
      >
        <GameScreen
          timer={timer}
          isAnimationStarted={backendPhase !== "BETTING"}
          onStageComplete={handleStageComplete}
          phase={phase}
          onSetPhase={setPhase}
          cashoutToasts={cashoutToast}
        />
      </Box>

      <Box className={styles.box1}>
        <Box className={styles.CardContainer}>
          {renderCard(0)}
          {showSecondCard && renderCard(1)}
        </Box>
        {showAllBet && <AllBet globalBets={globalBets} />}
      </Box>

      <AviatorResultPopup
        open={popupOpen}
        onClose={() => setPopupOpen(false)}
        resultData={selectedResult}
      />
      {historyOpen && (
        <Box
          className={styles.RoundHistory_overlay}
          onClick={() => setHistoryOpen(false)}
        >
          <Box
            className={styles.RoundHistory_box}
            onClick={(e) => e.stopPropagation()}
          >
            <Box className={styles.RoundHistory_header}>
              <Typography className={styles.RoundHistory_title}>
                Round History
              </Typography>
              <Box
                className={styles.RoundHistory_close}
                onClick={() => setHistoryOpen(false)}
              >
                <Typography
                  sx={{ color: "#fff", fontSize: "14px", lineHeight: 1 }}
                >
                  ×
                </Typography>
              </Box>
            </Box>
            <Box className={styles.RoundHistory_grid}>
              {resultData.map((odd, index) => (
                <Typography
                  key={index}
                  className={styles.RoundHistory_item}
                  sx={{ color: getOddColor(odd.result) }}
                  onClick={() => {
                    handleOpenPopup(odd);
                    setHistoryOpen(false);
                  }}
                >
                  {odd.result.toFixed(2)}x
                </Typography>
              ))}
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
}

export default Aviator;
